import { NgModule } from '@angular/core';
import { S3FileDownloaderComponent } from './s3-file-downloader.component';
import { MatButtonModule } from '@angular/material/button';
import { S3Service } from '../../services/s3/s3.service';
import { ElementBlockerModule } from '../element-blocker/element-blocker.module';
import { TranslateModule } from '@ngx-translate/core';
import { BlobService } from '../../services/file/blob.service';
import { TranslationService } from '../../services/translation/translation.service';
import { CommonModule } from '@angular/common';
import { ErrorHandlerService } from '../../services/error-handler/error-handler.service';

@NgModule({
  imports: [
    CommonModule,
    MatButtonModule,
    ElementBlockerModule,
    TranslateModule,
  ],
  declarations: [
    S3FileDownloaderComponent,
  ],
  providers: [
    S3Service,
    BlobService,
    TranslationService,
    ErrorHandlerService,
  ],
  exports: [
    S3FileDownloaderComponent,
  ],
})
export class S3FileDownloaderModule {
}
